import styled from 'styled-components'

export const Icon = styled.div`
  align-items: center;
  display: flex;
  height: 96px;
  justify-content: center;
  width: 96px;
`
